module.exports = __webpack_public_path__ + "media/images/icons/icon-close-dark-05db786eacb6cb28eea94f9f17723a55.svg";